import { useTheme } from '@material-ui/core';
import React, { useMemo } from 'react';
import Select from 'react-select';
import { components } from 'react-select';
import { useViewer } from 'src/hooks/use-viewer';
import LoadingIndicator from '~components/react-select/loading-indicator';
import { ArrowV } from '~static/svg-components';
import hexToRGBA from '~utils/hex-to-rgba';

const getOptionLabel = (option) => option?.name;
const getOptionValue = (option) => option?.id;

const DropdownIndicator = (props) => {
  const theme = useTheme();
  return (
    <components.DropdownIndicator {...props}>
      <ArrowV
        style={{
          width: '6px',
          height: '10px',
          padding: 0,
          color: theme.colors.grey66,
          fontSize: 'inherit',
          transform: props.selectProps.menuIsOpen
            ? 'rotate(270deg)'
            : 'rotate(90deg) translateX(2px)',
          transition: 'transform 150ms cubic-bezier(0.65, 0.05, 0.36, 1)',
        }}
      />
    </components.DropdownIndicator>
  );
};

const Control = (props) => {
  const { children, ...otherProps } = props;
  return <components.Control {...otherProps}>{props.children}</components.Control>;
};

function PropertySelect(props) {
  const theme = useTheme();
  const {
    currentRole: {
      accessScope: { properties },
    },
  } = useViewer();
  const { property, isDisabled, onChange, ...otherProps } = props;

  const customStyles = useMemo(
    () => ({
      control: () => ({
        borderWidth: '0px',
        borderColor: 'transparent',
        boxShadow: 'none',
        padding: 0,
        margin: 0,
        minHeight: 'auto',
        display: 'flex',
      }),
      singleValue: () => ({
        color: theme.colors.grey66,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        width: '100%',
        overflow: 'hidden',
        textAlign: 'left',
        fontSize: '14px',
        lineHeight: '24px',
      }),
      valueContainer: () => ({
        width: '100%',
        height: 24,
      }),
      menu: (provided) => ({
        ...provided,
        maxWidth: 240,
        boxShadow: `0 2px 8px 0 ${hexToRGBA(theme.colors.dark, 0.16)}`,
        marginBottom: 2,
        marginTop: 2,
        width: 'fit-content',
      }),
      menuList: (provided) => ({
        ...provided,
        maxHeight: 300,
      }),
      option: (provided, state) => ({
        ...provided,
        ...theme.typography.dropdown,
        ':active': { backgroundColor: 'inherit' },
        padding: '6px 12px',
        whiteSpace: 'nowrap',
        color: state.isSelected
          ? theme.colors.brandAction
          : state.isDisabled
          ? theme.colors.grey99
          : theme.colors.dark,
        backgroundColor: state.isFocused ? theme.colors.brandBg : provided.background,
        textAlign: 'left',
      }),
      dropdownIndicator: () => ({
        marginLeft: 8,
        fontSize: 10,
        color: theme.colors.brandMedium,
      }),
    }),
    [
      theme.colors.brandAction,
      theme.colors.brandBg,
      theme.colors.brandMedium,
      theme.colors.dark,
      theme.colors.grey66,
      theme.colors.grey99,
      theme.typography.dropdown,
    ]
  );

  return (
    <Select
      value={property}
      components={{
        IndicatorSeparator: null,
        DropdownIndicator: !isDisabled && DropdownIndicator,
        LoadingIndicator,
        Control,
      }}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      options={properties}
      isSearchable={false}
      styles={customStyles}
      onChange={onChange}
      isDisabled={isDisabled}
      {...otherProps}
    />
  );
}

export default PropertySelect;
